// Fires a transactional email through the send-bid-email Netlify function,
// which talks to SendGrid. Failures are logged but never thrown — email
// delivery should never block a bid, counter, or acceptance from going through.
export async function sendTransactionalEmail({ to, subject, text, html }) {
  if (!to) return;

  try {
    const response = await fetch('/.netlify/functions/send-bid-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ to, subject, text, html }),
    });
    if (!response.ok) {
      console.error('sendTransactionalEmail failed', response.status, await response.text());
    }
  } catch (err) {
    console.error('sendTransactionalEmail request failed', err);
  }
}
